(function () {
  function initFooterAccordion(section) {
    if (!section || section.dataset.sz26FooterInit === 'true') return;
    section.dataset.sz26FooterInit = 'true';

    var isDesktop = function () {
      return window.matchMedia('(min-width: 768px)').matches;
    };

    var cols = section.querySelectorAll('.sz-26-footer__col--accordion');
    if (!cols.length) return;

    cols.forEach(function (col) {
      var toggle = col.querySelector('.sz-26-footer__col-toggle');
      var wrap = col.querySelector('.sz-26-footer__links-wrap');
      if (!toggle || !wrap) return;

      function setOpen(open) {
        col.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          wrap.style.height = wrap.scrollHeight + 'px';
        } else {
          wrap.style.height = '0px';
        }
      }

      function syncDesktop() {
        if (isDesktop()) {
          col.classList.add('is-open');
          wrap.style.height = '';
          toggle.setAttribute('aria-expanded', 'true');
        } else if (wrap.style.height === '') {
          setOpen(false);
        } else if (!col.classList.contains('is-open')) {
          wrap.style.height = '0px';
          toggle.setAttribute('aria-expanded', 'false');
        }
      }

      toggle.addEventListener('click', function () {
        if (isDesktop()) return;
        setOpen(!col.classList.contains('is-open'));
      });

      if (isDesktop()) {
        setOpen(true);
      } else {
        setOpen(false);
      }

      window.addEventListener('resize', syncDesktop);
    });
  }

  function initNewsletterConsent(section) {
    var form = section.querySelector('.sz-26-footer__newsletter-form');
    var consent = section.querySelector('.sz-26-footer__consent-input');
    var submit = section.querySelector('.sz-26-footer__submit');
    if (!form || !consent || !submit) return;

    function syncSubmit() {
      submit.disabled = !consent.checked;
    }

    consent.addEventListener('change', syncSubmit);
    form.addEventListener('submit', function (e) {
      if (!consent.checked) {
        e.preventDefault();
      }
    });
    syncSubmit();
  }

  function boot() {
    document.querySelectorAll('.sz-26-footer').forEach(function (section) {
      initFooterAccordion(section);
      initNewsletterConsent(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.sz-26-footer');
    if (section) {
      section.dataset.sz26FooterInit = '';
      initFooterAccordion(section);
      initNewsletterConsent(section);
    }
  });
})();
